// extracted by mini-css-extract-plugin
export default {"commentsWrapper":"commentsWrapper---DgIFd","addCommentBtn":"addCommentBtn---cpVkA"};